import { createContext } from 'react';

const persons = [];
const formFields = [
    { id: 'form-name', name: 'name', label: 'Namn', value: '' },
    {
        id: 'form-organization',
        name: 'organization',
        label: 'Organisation',
        value: '',
    },
    { id: 'form-email', name: 'email', label: 'Email', value: '' },
    { id: 'form-phone', name: 'phone', label: 'Telefonnummer', value: '' },
    { id: 'form-role', name: 'role', label: 'Roll', value: '' },
];
const layout = [
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Namn',
        filterValue: 'Name',
        textValue: 'name',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Organisation',
        filterValue: 'Organization',
        textValue: 'organization',
    },
    {
        width: 200,
        filterType: 'select',
        type: 'skill',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Teknisk Miljö',
        filterValue: 'Skill',
        textValue: 'skills',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Email',
        filterValue: 'Email',
        textValue: 'email',
    },
    {
        width: 150,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Telefonnr',
        filterValue: 'Phone',
        textValue: 'phone',
    },
    {
        width: 150,
        filterType: 'select',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Roll',
        filterValue: 'Role',
        textValue: 'role',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Senaste Aktivitet',
        filterValue: 'LastActivityDate',
        textValue: 'lastActivityDate',
    },
    {
        width: 150,
        filterType: 'text',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Ägare',
        filterValue: 'Owner',
        textValue: 'owner',
    },
];

export const initialState = {
    apiUrl: 'crmPersonFront',
    layout: layout,
    persons: persons,
    rows: persons,
    activePerson: null,
    formFields: formFields,
    activityDealAlternatives: [],
    viewSettings: {
        minIndex: 0,
        maxIndex: 0,
        itemHeight: 40,
        totalHeight: 0,
        bufferHeight: 0,
        topPaddingHeight: 0,
        bottomPaddingHeight: 0,
        tolerance: 20,
    },
    requestObject: {
        startIndex: 0,
        amount: 30,
        tolerance: 20,
        filters: {},
    },
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_VIEW_SETTINGS_AND_REQUEST_OBJECT':
            return {
                ...state,
                viewSettings: action.viewSettings,
                requestObject: action.requestObject,
            };
        case 'UPDATE_VIEW_SETTINGS':
            return {
                ...state,
                viewSettings: action.viewSettings,
            };
        case 'UPDATE_REQUEST_OBJECT':
            return {
                ...state,
                requestObject: action.requestObject,
            };
        case 'UPDATE_PERSONS_AND_ACTIVE_PERSON':
            return {
                ...state,
                persons: action.persons,
                rows: action.persons,
                activePerson: action.activePerson,
            };
        case 'UPDATE_DATA':
            return {
                ...state,
                organizations: action.payload,
                rows: action.payload,
            };
        case 'UPDATE_ACTIVE_PERSON':
            return {
                ...state,
                activePerson: action.payload,
            };
        case 'UPDATE_FORM_FIELDS':
            let tmpFormFields = formFields;
            tmpFormFields[action.index].fields = action.payload;
            return {
                ...state,
                formFields: tmpFormFields,
            };
        case 'UPDATE_ACTIVITY_DEAL_ALTERNATIVES':
            return {
                ...state,
                activityDealAlternatives: action.payload,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
